import React, {useState} from 'react'
import styles from './index.module.scss'
import StorageService from "../../../../../services/storage.service";

export default function DropDownResolution({resolutionList, currentResolution, setCurrentResolution}) {
    const [openOptions, setOpenOptions] = useState(false);

    const clickOnResolution = (resolution) => {
        setCurrentResolution(resolution)
        setOpenOptions(false)

        StorageService.cameraResolution = JSON.stringify(resolution)
    }

    return (
        <div className={styles.popup}>
            <div className={styles.popup__line} onClick={() => setOpenOptions(!openOptions)}>
                <div>
                    {currentResolution.width} x {currentResolution.height}
                </div>
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                     style={{transform: "translateY(-1px)"}}>
                    <path d="M13 3L7 9L1 3" stroke="#323238" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            </div>
            <div className={`${styles.popup__options} ${openOptions && styles.open}`}>
                {resolutionList.map( (resolution, index) => (
                    <div className={styles.popup__item} key={index} onClick={() => clickOnResolution(resolution)}>
                        <div className={`${styles.popup__radio} ${(resolution.width === currentResolution.width) && (resolution.height === currentResolution.height) && styles.active}`}/>
                        {resolution.width} x {resolution.height}
                    </div>
                ))}
            </div>
        </div>
    )
}
